"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyEnum = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `USD` - USD
 * * `EUR` - EUR
 * * `RUB` - RUB
 */
var CurrencyEnum;
(function (CurrencyEnum) {
    CurrencyEnum["USD"] = "USD";
    CurrencyEnum["EUR"] = "EUR";
    CurrencyEnum["RUB"] = "RUB";
})(CurrencyEnum = exports.CurrencyEnum || (exports.CurrencyEnum = {}));
